export interface ElqrBank {
    id: string;
    name: string;
    launchBase: string;
    logo: string;
}

// Native ELQR handlers published by https://pay.payqr.kg/ (checked 2026-10-14).
// Keep the existing HTTPS app links for banks not listed by that router.
export const ELQR_BANKS: readonly ElqrBank[] = [
    { id: 'abank', name: 'AБанк', launchBase: 'abank-elqr://payqr.kg', logo: '/assets/banks/ab_logo-9be50e68.svg' },
    { id: 'obank', name: 'О!Банк', launchBase: 'elqr-obank://payqr.kg/', logo: '/assets/banks/obank_logo-cbd98b1b.svg' },
    { id: 'mbank', name: 'MBANK', launchBase: 'https://app.mbank.kg/qr/', logo: '/assets/banks/mbank_logo-a4fdd332.svg' },
    { id: 'optima', name: 'Optima', launchBase: 'elqr-optima://payqr.kg', logo: '/assets/banks/optima_logo-de302472.svg' },
    { id: 'demir', name: 'DemirBank', launchBase: 'https://retail.demirbank.kg/', logo: '/assets/banks/demir_logo-9f7d5a1b.svg' },
    { id: 'kompanion', name: 'Компаньон', launchBase: 'https://24.kompanion.kg/qr/', logo: '/assets/banks/kompanion_logo-0d053e58.png' },
    { id: 'bakai', name: 'Бакай', launchBase: 'https://bakai.app/', logo: '/assets/banks/bakai_logo-5968ab22.avif' },
    { id: 'elqr', name: 'ELQR', launchBase: 'https://pay.payqr.kg/', logo: '/assets/banks/elqr_logo-1bc93115.svg' },
];

// The caller supplies a verified payload. Preserve its transport encoding exactly.
export const getElqrLaunchUrl = (bank: ElqrBank, payload: string): string => `${bank.launchBase}#${payload}`;
export const getElqrRouterUrl = (payload: string): string => `https://pay.payqr.kg/#${payload}`;

export const getElqrQrValue = (payload: string, source?: string): string => {
    if (source) {
        try {
            const hashIndex = source.indexOf('#');
            if (new URL(source).protocol === 'https:' && hashIndex >= 0 && source.slice(hashIndex + 1) === payload) {
                return source;
            }
        } catch { /* A decoded image or bare payload uses the shared HTTPS router. */ }
    }
    // A native app launch URI is not the payment QR scanned inside a bank app.
    return getElqrRouterUrl(payload);
};
